import { DateTime } from 'luxon';

import { formatDate } from 'dashboard/lib/utils/formatters';
import Sticker from 'design-system/components/Sticker/Sticker';
import { ID_COLOR_MAP } from 'lib/constants/check';

export const getFullName = (metadata: Record<string, unknown>) => {
  if (metadata != null) {
    const { 'name-first': nameFirst, 'name-last': nameLast } = metadata;
    const fullName = [nameFirst, nameLast].filter(Boolean).join(' ') || '-';
    return fullName;
  } else {
    return '-';
  }
};

export const formatBirthdate = (birthdate: string | null | undefined) => {
  if (birthdate != null) {
    const formattedBirthdate = formatDate(birthdate);
    const formattedAge = Math.floor(
      DateTime.local().diff(DateTime.fromISO(birthdate), 'years').years,
    );
    return formattedBirthdate + ' (' + formattedAge + ' years old)';
  } else {
    return '-';
  }
};

export const formatColor = (color: string | null | undefined) => {
  if (color == null) {
    return '-';
  } else {
    const displayValue = ID_COLOR_MAP[color];
    return displayValue ? color + ' (' + displayValue + ')' : color;
  }
};

export const displayIdNumber = (idNumber: string | undefined, hasPermissionToView: boolean) => {
  if (hasPermissionToView) {
    return idNumber;
  } else {
    return <Sticker variant='basic'>Missing Permission to view ID Number</Sticker>;
  }
};
